import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';

export const getNotifications = createAsyncThunk('notifications/getNotifications', async (params = {}, { rejectWithValue }) => {
  try {
    const response = await api.get('/notifications', { params });
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getUnreadCount = createAsyncThunk('notifications/getUnreadCount', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/notifications/unread/count');
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const markAsRead = createAsyncThunk('notifications/markAsRead', async (id, { rejectWithValue }) => {
  try {
    const response = await api.put(`/notifications/${id}/read`);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const notificationSlice = createSlice({
  name: 'notifications',
  initialState: {
    notifications: [],
    unreadCount: 0,
    pagination: { page: 1, limit: 20, total: 0, pages: 0 },
    isLoading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getNotifications.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getNotifications.fulfilled, (state, action) => {
        state.isLoading = false;
        state.notifications = action.payload.notifications;
        state.pagination = action.payload.pagination;
      })
      .addCase(getUnreadCount.fulfilled, (state, action) => {
        state.unreadCount = action.payload.count;
      })
      .addCase(markAsRead.fulfilled, (state, action) => {
        const notification = state.notifications.find(n => n._id === action.payload._id);
        if (notification) {
          notification.status = 'delivered';
          state.unreadCount = Math.max(0, state.unreadCount - 1);
        }
      });
  }
});

export default notificationSlice.reducer;